// Non-translatable data only. All user-visible strings live in /app/frontend/src/i18n/translations.js

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_startup-growth-4/artifacts/btbz6tz9_tova%20shte%20e.png";

export const NAV_IDS = [
  { id: "about", testId: "nav-about-link", labelKey: "about" },
  { id: "program", testId: "nav-program-link", labelKey: "program" },
  { id: "team", testId: "nav-team-link", labelKey: "team" },
  { id: "faq", testId: "nav-faq-link", labelKey: "faq" },
  { id: "contact", testId: "nav-contact-link", labelKey: "contact" },
];

// Founders' structural data (images, contacts). Names, roles, and bios are translated.
export const FOUNDERS = [
  {
    id: "margarit",
    image:
      "https://customer-assets.emergentagent.com/job_startup-growth-4/artifacts/ydcbw56e_Margarit%202.JPG",
    email: "m.arnaudov@velocitas.bg",
    phone: "+359 889 128 442",
    phoneHref: "+359889128442",
    nameEn: "Margarit Arnaudov",
    nameBg: "Маргарит Арнаудов",
  },
  {
    id: "vasil",
    image:
      "https://customer-assets.emergentagent.com/job_startup-growth-4/artifacts/02pn1833_Vasil%206.png",
    imageClass:
      "w-full h-full object-cover object-top grayscale-[15%] hover:grayscale-0 transition-all duration-700",
    email: "v.vezenkov@velocitas.bg",
    phone: "+359 876 730 306",
    phoneHref: "+359876730306",
    nameEn: "Vasil Vezenkov",
    nameBg: "Васил Везенков",
  },
];

export const founderName = (founder, lang) =>
  lang === "bg" ? founder.nameBg : founder.nameEn;
